/**
 * BAŞLATILAN İSTEKLERİN İPTAL SİNYALİ — çağıranın her uca ayrı ayrı geçirmediği (31 Ekim 2026,
 * UI/UX denetimi K-A20).
 *
 * Üst arama (⌘K) bir terim için on beş ayrı özelliğin liste ucunu çağırıyor ve hiçbiri sinyal
 * almıyordu: «Sel», «Seli», «Selin» yazan kişi üç terimin kırk beş isteğini sonuna kadar
 * bekletiyordu; sunucu cevabı kimsenin okumayacağı aramaları yürütüyordu. Sinyali on beş
 * özelliğin API dosyasına tek tek eklemek yerine, istekleri başlatan EŞZAMANLI blok sinyali
 * burada bırakıyor ve istemcinin `send`'i onu, kendi sinyali olmayan her isteğe takıyor.
 *
 * Yalnız eşzamanlı kısım: `start` dönünce sinyal kalkıyor. Bir istek `send`'e ilk `await`'ten
 * önce ulaşıyor (`api.get` → `request` → `send` → `fetch` arasında bekleme yok), yani bloğun
 * içinde başlayan her istek sinyali alıyor, dışında başlayan hiçbiri almıyor.
 */
let ambientSignal: AbortSignal | undefined;

export function withRequestSignal<T>(signal: AbortSignal | undefined, start: () => T): T {
  const previous = ambientSignal;
  ambientSignal = signal;
  try {
    return start();
  } finally {
    ambientSignal = previous;
  }
}

/** The signal of the block that is starting requests right now — read by `send` in `client.ts`. */
export function requestSignal(): AbortSignal | undefined {
  return ambientSignal;
}

/*
  AYRI MODÜL, `client.ts`'in içinde değil: istemciyi `vi.mock` ile sahteleyen sınamalar (üst arama,
  kabuk) bu işlevi de sahtelemek zorunda kalmasın — burada yalnız bir değişken var, ağ yok.
*/
